exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.marketing-box .el-tabs__item {\n  font-size: 12px;\n}\n.setlink-footer-btn{ width: 160px;\n}\n.setlink-set-link{ width: 500px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/components/setlink/Setlink.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD,qBAAqB,aAAa;CACjC;AACD,mBAAmB,aAAa;CAC/B","file":"Setlink.vue","sourcesContent":["\n.marketing-box .el-tabs__item {\n  font-size: 12px;\n}\n.setlink-footer-btn{ width: 160px;\n}\n.setlink-set-link{ width: 500px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a13dc89","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/setlink/Setlink.vue
// module id = tp9C
// module chunks = 0